<template>
    <div>
        <h4>{{ title }}</h4>
        <van-empty v-if="empty" description="暂无提交记录"></van-empty>
        <div class="result-wrapper" v-else>
            <van-icon name="passed" />
            <div>提交成功（测试{{ text }}）</div>
        </div>
        <div v-if="autoJump" class="tip">将在3s内前往咨询</div>
    </div>
</template>
<script>
import { getSubmitResult } from '@/service'
import { PutTransition, GetTicketDetail } from '@custouch/proxy-use'
const {
    VUE_APP_TICKET_SAMPLE,
    VUE_APP_TICKET_SAMPLE_ID,
    VUE_APP_SAMPLE_RESEARCH_FORM,
    VUE_APP_SAMPLE_RESEARCH_TEST_ITEM,
    VUE_APP_SAMPLE_RESEARCH_TEST_CONFIRM,
    VUE_APP_SAMPLE_RESEARCH_TEST_NUMBER,
    VUE_APP_SAMPLE_RESEARCH_REQUEST
} = window.env
const sampleIds = VUE_APP_TICKET_SAMPLE
export default {
    props: {
        title: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            empty: false,
            text: false,
            autoJump: false
        }
    },
    created() {
        this.init()
    },
    methods: {
        async init() {
            const { c_m_ticketNumber } = this.$route.query
            const data = await getSubmitResult(VUE_APP_SAMPLE_RESEARCH_FORM, [
                VUE_APP_SAMPLE_RESEARCH_TEST_ITEM,
                VUE_APP_SAMPLE_RESEARCH_TEST_NUMBER,
                ...VUE_APP_SAMPLE_RESEARCH_REQUEST.map(t => t.itemName)
            ])
            const res = data.find(t =>
                t.options.find(t => t.value === c_m_ticketNumber)
            )
            if (res) {
                const dic = res.options.reduce((pre, cur) => {
                    pre[cur.itemName] = cur
                    return pre
                }, {})
                const { value, valueDisplay } = dic[
                    VUE_APP_SAMPLE_RESEARCH_TEST_ITEM
                ]
                this.text = valueDisplay
                const { value: ticketNumber } = dic[
                    VUE_APP_SAMPLE_RESEARCH_TEST_NUMBER
                ]
                const reply = VUE_APP_SAMPLE_RESEARCH_REQUEST.find(
                    t => dic[t.itemName]?.valueDisplay.length === 1
                )
                // 3s后自动跳转
                if (reply) {
                    this.autoJump = true
                    setTimeout(() => {
                        this.$router.replace({
                            name: 'questionDetailFromSample',
                            params: {
                                ticketNumber: c_m_ticketNumber,
                                projectId: VUE_APP_TICKET_SAMPLE_ID
                            },
                            query: {
                                rName: reply.itemName
                            }
                        })
                    }, 3000)
                }
                if (!ticketNumber) return
                if (value === VUE_APP_SAMPLE_RESEARCH_TEST_CONFIRM) {
                    // 测试过的,流转到已评价（已测试）
                    await this.changeStatus({
                        ticketNumber,
                        statusId: sampleIds.tested
                    })
                } else {
                    // 未测试的，流转到已评价（未测试）
                    await this.changeStatus({
                        ticketNumber,
                        statusId: sampleIds.estimated
                    })
                }
            } else {
                this.empty = true
            }
        },
        async changeStatus({ ticketNumber, statusId }) {
            const {
                ticket: {
                    status: { statusId: _statusId }
                }
            } = await GetTicketDetail({
                projectId:VUE_APP_TICKET_SAMPLE_ID,
                ticketNumber,
                withLogs:false
            }
            )
            if (_statusId == statusId) return
            return PutTransition({
                projectId: VUE_APP_TICKET_SAMPLE_ID,
                ticketNumber,
                statusId
            })
        }
    }
}
</script>
<style lang="less" scoped>
@import '~@/assets/style/mixin.less';

h4 {
    text-align: center;
    padding: @padding-md;
}
.result-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 20px;
    color: @green;
    & > *:not(:last-child) {
        margin-bottom: @padding-sm;
    }
    i {
        font-size: 40px;
    }
}
.tip{
    text-align: center;
    margin-top: 1rem;
}
</style>
